import React from 'react';

import ic_close from 'image/ic_close.svg';

const InputMultiImages = ({label, files, name, onChange, images, handleDeleteImageClick, imageLabel}) => {
  const handleDelete = (img) => {
    handleDeleteImageClick(img);
  }

  return (
    <div className="InputMultiImages wrap-adminInput">
      <label className="input-label" htmlFor={name}>{label}</label>

      <div className="wrap-file">
        {images[0] 
        ? images.map((img, index) => {
            const bgStyle = {backgroundImage : `url('${img.imageUrl}')`}
            return  <div className="inner-file" key = {index}>
                      <div className="wrap-image" style = {bgStyle}>
                      </div>
                      <div className="wrap-btns">
                        <img src={ic_close} alt="delete" onClick = {() => {handleDelete(img)}}/>
                      </div>
                    </div>
          })
        : ""}
        


        <div className="inner-file">
          <label className = {`input-el cursor ${files ? `active` : ""}`} htmlFor={name}>{imageLabel}</label>
        </div>
      </div>

      <input type="file" onChange={onChange} name = {name} id = {name} />
    </div> 
  );
}

export default InputMultiImages;